import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { GetStartedProgress } from '../../types/company.types';
import { StakeholderRole } from '../../types/stakeholder.types';
import { Company } from '../index';
import { useAppQuery } from '../use-app-query.hook';
import { useLocale } from '../use-locale.hook';

type FetchCompany = {
  companyId: string;
  enabled?: boolean;
};

export const useGetStartedProgress = ({ companyId, enabled }: FetchCompany) => {
  const queryClient = useQueryClient();
  const { locale } = useLocale();
  const { selectedCompany: { roleInCompany } = {} } = Company.useSelected();
  const { data: companyProgress, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_COMPANY_GET_STARTED_PROGRESS, companyId],
    queryFn: () =>
      ApiService.get<GetStartedProgress>(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'get-started-progress'] },
        { locale },
      ),
    enabled: !!companyId && roleInCompany === StakeholderRole.ADMIN && enabled,
  });
  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_COMPANY_GET_STARTED_PROGRESS] });
  }, [queryClient]);

  return {
    isLoading,
    invalidateQuery,
    companyProgress,
  };
};
